module.exports = __webpack_public_path__ + "static/media/eionet-logo.55e23d36.png";